import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateLangPipe } from 'src/app/components/shared/pipes/translateLang.pipe';
import { ValidDatePipe } from 'src/app/pipes/valid-date.pipe';

@NgModule({
  declarations: [
    TranslateLangPipe,
    ValidDatePipe,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    TranslateLangPipe,
    ValidDatePipe,
  ],
})
export class SharedPipeModule {}